import * as React from 'react';
import { RouteComponentProps, withRouter, Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import bindAllOfThis from 'src/utils/BindThisHelper';
import Routes from 'src/core/Routes';
import { PageProps } from "src/models/common/ComponentProps";
import { ReduxStoreModel } from "src/redux/ReduxModel";
import { UserState } from "src/redux/UserReducer";
import { Spin } from "antd";

interface EmulateUserProps extends PageProps<{}> {
    // From Redux
    User: UserState;
}

interface EmulateUserState {
}

class EmulateUser extends React.Component<EmulateUserProps, EmulateUserState> {
    constructor(props: EmulateUserProps) {
        super(props);
        bindAllOfThis(this, EmulateUser.prototype);
    }

    render() {
        // If loading is complete, redirect to redux.config.previous page
        // if nothing in there, maybe send them to the login page? maybe just send them there anyway...
        if (this.props.User.state === "finished") {
            return <Redirect to={Routes.LOGIN} />;
        }

        return <div className="emulate-user">
            <h2>Emulating User</h2>
            <Spin size="large" />
            <p>Please wait while we prepare the emulation request</p>
        </div>;
    }
}

function mapStateToProps(state: ReduxStoreModel) {
    return {
        User: state.User
    };
}

export default connect(mapStateToProps)(EmulateUser);



// WEBPACK FOOTER //
// ./src/pages/admin/EmulateUser.tsx